import React, { ReactNode, useEffect } from "react"
import {
    getDownloadAllLink,
    clearDownloadAllLink
} from "../../../../../Actions/API/Job/JobDownloadActions"
import { connect } from "react-redux"
import { isValid } from "../../../../../Models/API/JobModel"
import { State, MainThunkDispatch } from "../../../../../Reducers"
import { Confirm } from "../../../../Common/Modal/Confirm"
import { push } from "connected-react-router"

interface DownloadRefHandlerProps {
    downloadRef?: string
    appID: string
    redirectToOnClose: string
    children: ReactNode
}

interface StateProps {
    downloadLink?: string
}

interface DispatchProps {
    getDownloadLink: (filename: string) => void
    downloadFile: (link: string) => void
    close: () => void
}

type Props = DownloadRefHandlerProps & StateProps & DispatchProps

export const DownloadRefHandlerIsolated: React.FC<Props> = ({
    downloadRef,
    children,
    downloadFile,
    downloadLink,
    getDownloadLink,
    close
}: Props) => {
    const handleDownload = () => {
        if (downloadLink) downloadFile(downloadLink)
        close()
    }

    useEffect(() => {
        if (downloadRef && !downloadLink) {
            getDownloadLink(downloadRef)
        }
    }, [downloadRef, getDownloadLink, downloadLink])

    return (
        <>
            {children}
            {downloadLink && (
                <Confirm
                    title="Download data"
                    description={"Click OK to download your requested file."}
                    yesLabel="OK"
                    onClickYes={handleDownload}
                    onClickNo={close}
                    onClose={close}
                />
            )}
        </>
    )
}

const mapStateToProps = (
    state: State,
    { appID }: DownloadRefHandlerProps
): StateProps => {
    const download = state.api.downloadJobs[appID]?.download

    return {
        downloadLink:
            download !== undefined && isValid(download)
                ? download.link
                : undefined
    }
}

const mapDispatchToProps = (
    dispatch: MainThunkDispatch,
    { appID, redirectToOnClose }: DownloadRefHandlerProps
): DispatchProps => {
    return {
        getDownloadLink: (filename: string) =>
            dispatch(getDownloadAllLink(appID, filename)),
        downloadFile: (link: string) =>
            window.open(link, "_blank", "noopener,noreferrer"),
        close: () => {
            dispatch(push(redirectToOnClose))
            dispatch(clearDownloadAllLink(appID))
        }
    }
}

export const DownloadRefHandler = connect(
    mapStateToProps,
    mapDispatchToProps
)(DownloadRefHandlerIsolated)
